import React from "react";
import PropTypes from "prop-types";

const features = [
    {
        title: "Field Research",
        amount: "100+ Sites",
        icon: "🌍",
    },
    {
        title: "Lab Analysis",
        amount: "Advanced Tools",
        icon: "🧪",
    },
    {
        title: "Career Opportunities",
        amount: "High Demand",
        icon: "🏗️",
    },
];


const FeaturedItem = ({ feature }) => {
    const { title, amount, icon } = feature;
    return (
        <div className="bg-white dark:bg-slate-800 shadow-xl rounded-xl p-5 transition-all duration-300 hover:shadow-2xl hover:scale-105 border border-gray-100 dark:border-slate-700 h-40 flex flex-col items-center justify-center text-center">
            <div className="text-2xl mb-1">{icon}</div>
            <h4 className="text-2xl sm:text-3xl text-blue-600 dark:text-blue-400 font-bold mb-1">{amount}</h4>
            <h6 className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</h6>
        </div>
    );
};

FeaturedItem.propTypes = {
    feature: PropTypes.object.isRequired,
};

const Feature55 = () => {
    return (
        <section className="py-16 md:py-24 bg-gradient-to-b from-white to-blue-50 dark:from-[#0b1727] dark:to-[#0a1520] text-black dark:text-white overflow-hidden">
            {/* Mobile-friendly background decorations */}
            <div className="hidden md:block absolute top-0 right-0 w-64 h-64 bg-blue-100 dark:bg-blue-900/20 rounded-full -mr-32 -mt-32 blur-3xl"></div>
            <div className="hidden md:block absolute bottom-0 left-0 w-96 h-96 bg-blue-50 dark:bg-blue-900/10 rounded-full -ml-48 -mb-48 blur-3xl"></div>
            
            <div className="container mx-auto px-4 sm:px-6 relative">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    <div className="w-full mx-auto">
                        <div className="relative mx-auto max-w-md md:max-w-full">
                            <div className="absolute inset-0 bg-blue-600/10 dark:bg-blue-600/20 rounded-2xl transform rotate-3"></div>
                            <img
                                src="https://images.ctfassets.net/szez98lehkfm/2Qwz30ULkI9f1zde85dTeF/73fd5ee75b798d5a1b0a04261d5326c9/MyIC_Article_81208?w=730&h=410&fm=jpg&fit=fill"
                                alt="Banking services illustration"
                                className="relative max-w-full h-auto rounded-xl shadow-lg transform -rotate-2 z-10"
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <div className="mb-4 inline-block px-3 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 rounded-full text-sm font-medium">Earth Exploration</div>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight mb-4 text-blue-600 dark:text-blue-400">
                            Why Choose Us?
                        </h2>
                        <p className="text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed mb-8">
						Exploring the Earth’s mysteries starts with the right foundation in geological science.
						 Discover how this field uncovers natural resources, supports sustainability, and helps 
						 shape a better future!
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                            {features.map((feature, i) => (
                                <div key={i} className="w-full">
                                    <FeaturedItem feature={feature} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Feature55;